import React from 'react';
import { observer } from 'mobx-react-lite';
import ScreenNavigationModel, {
  ScreenType
} from '../models/ScreenNavigationModel';
import ChooseCorporateCategory from './screens/ChooseCorporateCategory';
import CorporateCategory from './screens/CorporateCategory';
import SelectYourCompany from './screens/SelectYourCompany';
import CompanyNotIncluded from './screens/CompanyNotIncluded';
import EnterYourCompanyData from './screens/EnterYourCompanyData';
import NotFoundCompany from './screens/NotFoundCompany';
import EnterCompanyDomain from './screens/EnterCompanyDomain';
import SearchForBusiness from './screens/SearchForBusiness';

const ScreenRenderer: React.FC = observer(() => {
  const currentScreen = ScreenNavigationModel.currentScreen;

  switch (currentScreen) {
    case ScreenType.SEARCH_FOR_BUSINESS:
      return <SearchForBusiness />;

    case ScreenType.CHOOSE_CORPORATE_CATEGORY:
      return <ChooseCorporateCategory />;

    case ScreenType.CORPORATE_CATEGORY:
      return <CorporateCategory />;

    case ScreenType.SELECT_YOUR_COMPANY:
      return <SelectYourCompany />;

    case ScreenType.COMPANY_NOT_INCLUDED:
      return (
        <CompanyNotIncluded
          onSearch={(companyName: string, zipOrCity: string) => {
            //console.log('Search for:', companyName, zipOrCity);
          }}
          onNoProfile={() => {}}
        />
      );

    case ScreenType.ENTER_YOUR_COMPANY_DATA:
      return (
        <EnterYourCompanyData
        />
      );

    case ScreenType.NOT_FOUND_COMPANY:
      return (
        <NotFoundCompany/>
      );

    case ScreenType.ENTER_COMPANY_DOMAIN:
      return <EnterCompanyDomain />;

    default:
      return <ChooseCorporateCategory />;
  }
});

export default ScreenRenderer;
